var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getLayoutMode,attrs:{"id":"app"}},[_c('router-view'),_c('ASpin',{staticClass:"spinning",attrs:{"spinning":_vm.spinning,"tip":"加载中..."}}),_c('Mqtt',{staticClass:"spinning"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }